import React from 'react';
import Reflux from 'reflux';
import classnames from 'classnames';
import {
  FixedEditorWidth,
  ZoomPercentages,
  ZoomPercentageDefaultIndex,
  PlaceholderText,
  LineHeightPercentages,
  LineHeightPercentageDefaultIndex,
} from 'shared/constants/FeaturedEditorConstants';
import role from 'shared/lib/role';
import { ColumnWidthStrings } from 'flux/stores/cuesheet/CuesheetConstants';
import RowPanel from 'main/components/show/cuesheet.prompter/rowPanel';
import UtilityPanel from 'main/components/show/cuesheet.prompter/utilityPanel';
import TeleprompterWelcomeModal from 'shared/components/misc/teleprompterWelcomeModal.jsx';
import TeleprompterOnboardingOverlay from 'shared/components/misc/teleprompterOnboardingOverlay.jsx';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PermissionStore from 'flux/stores/PermissionStore';
import UserActions from 'flux/actions/UserActions';
import TeamViewStore from 'flux/stores/TeamViewStore';
import EventViewStore from 'flux/stores/EventViewStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import FullScreenCuesheetStore from 'flux/stores/cuesheet.fullscreen/FullScreenCuesheetStore';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import EventShowListStore from 'flux/stores/EventShowListStore';
import RouteActions from 'flux/actions/RouteActions';
import VersionNumberActions from 'flux/actions/VersionNumberActions';
import IntercomActions from 'flux/actions/IntercomActions';
import { teleprompter as TeleprompterOnboarding } from 'shared/constants/Onboarding';
import ReactWindowPrompterList from 'main/components/show/cuesheet.prompter/reactWindowPrompterList';

import PrompterAlertBar from 'main/components/show/cuesheet.prompter/prompterAlertBar';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import keyBinder from 'shared/lib/keyBinder';
import { KeyScopes } from 'flux/stores/cuesheet/CuesheetConstants';
import RemoteTeleprompterStore from 'flux/stores/cuesheet.fullscreen/RemoteTeleprompterStore';
import getInnerWindowDimensions from 'main/util/getInnerWindowDimensions.js';
import EventCrewListStore from 'flux/stores/EventCrewListStore';
import RealTimeActions from 'flux/actions/RealTimeActions';

const {
  teleprompterWelcomeModal,
  teleprompterSelectColumn,
  teleprompterSelectRow,
} = TeleprompterOnboarding;

const viewMenuPopoverId = 'cs-view-menu';
const defaultRteText = PlaceholderText;

export default React.createClass({
  displayName: 'Teleprompter',

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(FullScreenCuesheetStore, 'fullScreenCuesheet'),
    Reflux.connect(RemoteTeleprompterStore, 'remoteTeleprompter'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connectFilter(EventShowListStore, 'shows', (state) =>
      state.get('shows'),
    ),
    Reflux.connectFilter(PermissionStore, 'permissions', (state) =>
      state.get('permissions'),
    ),
    Reflux.connect(EventCrewListStore, 'crew'),
    Reflux.listenTo(
      FullScreenCuesheetActions.updateEditorDimensions,
      '_updateDimensions',
    ),
  ],

  getInitialState() {
    const {
      panelWidth,
      editorWidth,
      editorHeight,
      windowHeight,
    } = this._getDimensions();

    return {
      panelWidth,
      editorWidth,
      editorHeight,
      windowHeight,
    };
  },

  componentWillMount() {
    /**
     * Add event listener
     */
    window.addEventListener('resize', this._updateDimensions);
    const { remote, eventId, showId, userId } = this.props;
    const { user } = this.state;
    const operatorUserId = remote ? userId : user.get('_id');
    RealTimeActions.subscribeToPrompterUser(operatorUserId, eventId, showId);
  },

  componentDidMount() {
    /**
     * Hide unnecessary elements from view
     */
    VersionNumberActions.hide();
    IntercomActions.hideChat(true);
    this._updateDimensions();
  },

  componentWillUnmount() {
    VersionNumberActions.show();

    IntercomActions.hideChat(false);

    /**
     * Remove event listener
     */
    window.removeEventListener('resize', this._updateDimensions);
  },

  render() {
    const { showId, eventId, teamId, remote } = this.props;

    const {
      fullScreenCuesheet,
      editorWidth,
      user,
      team,
      event,
      permissions,
      popoverVisibility,
      shows,
      panelWidth,
      windowHeight,
      crew,
    } = this.state;

    const {
      cachedRowOrder,
      cachedRowMap,
      forceOnboardingWelcome,
      rowOrder,
      rowMap,
      itemSetId,
      rowPanel,
      columns,
      utilityPanel,
      activityAudit,
      autoScrollSpeedIndex,
      userSettings,
      fullScreenEnabled,
      prompterWidthIndex,
      trackingEnabled,
      trackedUserId,
      trackableUsers,
      show,
    } = fullScreenCuesheet;

    const {
      prompterRealTimeEditsEnabled,
      prompterReadArrowEnabled,
      prompterItemInfoEnabled,
      prompterSingleItemEnabled,
      prompterTextMirror,
      prompterTextVerticalMirror,
      featuredCapitalization,
      featuredFontWeight,
      featuredZoom,
      featuredLineHeight,
    } = userSettings;

    const item = this._getRowItem();

    const editorText = this._getEditorStateText(item);

    const userOnboarding =
      user && user.get('onboarding') ? user.get('onboarding').toJS() : {};

    const hasSeenOnboardingWelcome =
      userOnboarding[teleprompterWelcomeModal] || false;
    const hasSeenOnboardingColumnSelection =
      userOnboarding[teleprompterSelectColumn] || false;
    const hasSeenOnboardingRowSelection =
      userOnboarding[teleprompterSelectRow] || false;

    const displayOnboardingWelcome =
      forceOnboardingWelcome || !hasSeenOnboardingWelcome;
    const displayOnboardingOverlay =
      !hasSeenOnboardingRowSelection || !hasSeenOnboardingColumnSelection;

    const disableUtilityPanelHover =
      displayOnboardingWelcome ||
      displayOnboardingOverlay ||
      popoverVisibility.get(viewMenuPopoverId);
    const disableRowPanelHover =
      displayOnboardingWelcome || displayOnboardingOverlay;

    if (remote && show && show.disableRemotePrompter) return null;

    return (
      <div className="teleprompter-wrapper">
        {!remote && (
          <div>
            <TeleprompterWelcomeModal
              display={displayOnboardingWelcome}
              onHide={this._onHideModal}
            />
            {displayOnboardingOverlay && (
              <TeleprompterOnboardingOverlay
                display={
                  !hasSeenOnboardingRowSelection ||
                  !hasSeenOnboardingColumnSelection
                }
                columnSelectionActive={!hasSeenOnboardingColumnSelection}
                rowSelectionActive={
                  hasSeenOnboardingColumnSelection &&
                  !hasSeenOnboardingRowSelection
                }
                width={editorWidth}
                onCreateColumn={this._handleCreateColumn}
                teamId={teamId}
                eventId={eventId}
              />
            )}
            <RowPanel
              open={displayOnboardingOverlay || rowPanel}
              activeShowId={showId}
              width={panelWidth}
              windowHeight={windowHeight}
              disablePanelHover={disableRowPanelHover}
              itemSetId={itemSetId}
              rowOrder={cachedRowOrder || rowOrder}
              rowMap={cachedRowMap || rowMap}
              trackingEnabled={trackingEnabled}
              trackedUserId={trackedUserId}
              trackableUsers={trackableUsers}
              onRowSelect={this._handleRowSelection}
              onShowSelect={this._handleShowSelection}
              loading={this._isLoading()}
              shows={shows}
              {...this.props}
            />
            <UtilityPanel
              text={editorText}
              open={displayOnboardingOverlay || utilityPanel}
              disablePanelHover={disableUtilityPanelHover}
              {...{
                team,
                event,
                activityAudit,
                user,
                autoScrollSpeedIndex,
                featuredZoom,
                featuredLineHeight,
                prompterReadArrowEnabled,
                prompterItemInfoEnabled,
                prompterSingleItemEnabled,
                featuredFontWeight,
                featuredCapitalization,
                prompterTextMirror,
                prompterTextVerticalMirror,
                prompterWidthIndex,
                prompterRealTimeEditsEnabled,
                crew,
              }}
              hasSeenOnboardingColumnSelection={
                hasSeenOnboardingColumnSelection
              }
              columns={columns}
              onSettingsChange={this._handlePrompterSettingChange}
              onColumnChange={this._handleColumnChange}
              onZoomChange={this._handleFeaturedZoomChange}
              onLineHeightChange={this._handleFeaturedLineHeightChange}
              width={panelWidth}
              loading={this._isLoading()}
              fullScreenEnabled={fullScreenEnabled}
              {...this.props}
            />
          </div>
        )}
        <div
          style={{ width: editorWidth }}
          className={classnames(
            'featured-fullscreen-editor-wrapper featured-editor-wrapper',
          )}
        >
          {!remote && permissions && (
            <PrompterAlertBar permissions={permissions} />
          )}
          {this._getEditor()}
        </div>
      </div>
    );
  },

  _onHideModal() {
    const { user } = this.state;

    const userOnboarding = user.get('onboarding')
      ? user.get('onboarding').toJS()
      : {};
    const hasSeenOnboardingWelcome =
      userOnboarding[teleprompterWelcomeModal] || false;

    if (!hasSeenOnboardingWelcome) {
      UserActions.updateOnboarding(
        user.get('_id'),
        teleprompterWelcomeModal,
        true,
      );
    }

    ModalActions.hide(UIRegions.TeleprompterWelcomeModal);
    FullScreenCuesheetActions.setForceOnboardingWelcome(false);
    FullScreenCuesheetActions.resetPrompterTrialCountdown();
  },

  _handleRowSelection(selectedRowId) {
    const { user } = this.state;

    FullScreenCuesheetActions.scrollToRowIdInPrompter(selectedRowId);

    UserActions.updateOnboarding(user.get('_id'), teleprompterSelectRow, true);
  },

  _handleShowSelection(show) {
    const { teamId, eventId } = this.props;
    RouteActions.goToTeleprompterInitialization({
      teamId,
      eventId,
      showId: show.get('_id'),
    });
  },

  _handleCreateColumn(columnTitle) {
    const { user } = this.state;

    FullScreenCuesheetActions.addColumn({
      title: columnTitle,
      width: ColumnWidthStrings.ScriptWide,
    });

    UserActions.updateOnboarding(
      user.get('_id'),
      teleprompterSelectColumn,
      true,
    );
  },

  _handleColumnChange(columnIndex) {
    const { fullScreenCuesheet, user } = this.state;
    const activeColumn = fullScreenCuesheet.columns[columnIndex];

    FullScreenCuesheetActions.saveFeaturedColumn(activeColumn._id);

    UserActions.updateOnboarding(
      user.get('_id'),
      teleprompterSelectColumn,
      true,
    );
  },

  _handlePrompterSettingChange(field, value) {
    const {
      teamId,
      eventId,
      showId,
      rowId,
      columnId,
      lineHeight,
      fontWeight,
      zoom,
    } = this.props;

    FullScreenCuesheetActions.saveUserSettings(
      field,
      value,
      { teamId, eventId, showId, rowId, columnId },
      { zoom, lineHeight, fontWeight },
    );
  },

  _handleFeaturedZoomChange(zoomIndex) {
    const {
      teamId,
      eventId,
      showId,
      rowId,
      columnId,
      lineHeight,
      fontWeight,
    } = this.props;

    const zoomPercent = ZoomPercentages[zoomIndex];
    const query = { zoom: zoomPercent, lineHeight, fontWeight };

    FullScreenCuesheetActions.saveUserSettings(
      'featuredZoom',
      zoomPercent,
      { teamId, eventId, showId, rowId, columnId },
      query,
    );
  },

  _handleFeaturedLineHeightChange(lineHeightIndex) {
    const {
      teamId,
      eventId,
      showId,
      rowId,
      columnId,
      zoom,
      fontWeight,
    } = this.props;

    const linePercent = LineHeightPercentages[lineHeightIndex];
    const query = { zoom, lineHeight: linePercent, fontWeight };

    FullScreenCuesheetActions.saveUserSettings(
      'featuredLineHeight',
      linePercent,
      { teamId, eventId, showId, rowId, columnId },
      query,
    );
  },

  _getZoom() {
    const { zoom } = this.props;
    return typeof zoom === 'number'
      ? ZoomPercentages[zoom]
      : ZoomPercentages[ZoomPercentageDefaultIndex];
  },

  _getLineHeight() {
    const { lineHeight } = this.props;
    return typeof lineHeight === 'number'
      ? LineHeightPercentages[lineHeight]
      : LineHeightPercentages[LineHeightPercentageDefaultIndex];
  },

  _getEditor() {
    if (this._isLoading()) {
      return (
        <div className="featured-editor-placeholder">
          <div className="featured-editor-placeholder-line-wrapper-body">
            <div className="loading-animation" />
            <div className="loading-animation" />
            <div className="loading-animation" />
            <div className="loading-animation" />
            <div className="loading-animation" />
          </div>
        </div>
      );
    }

    return (
      <div className={classnames('featured-fullscreen-editor featured-editor')}>
        {this._getPrompterList()}
      </div>
    );
  },

  _getZoomIndex() {
    const { fullScreenCuesheet } = this.state;

    const { userSettings } = fullScreenCuesheet;
    const { featuredZoom } = userSettings;

    let zoomIndex = Object.keys(ZoomPercentages).find(
      (key) => ZoomPercentages[key] === featuredZoom,
    );
    zoomIndex =
      !zoomIndex || zoomIndex === -1
        ? ZoomPercentageDefaultIndex
        : parseInt(zoomIndex);

    return zoomIndex;
  },

  _getLineHeightIndex() {
    const { fullScreenCuesheet } = this.state;

    const { userSettings } = fullScreenCuesheet;
    const { featuredLineHeight } = userSettings;

    let lineHeightIndex = Object.keys(LineHeightPercentages).find(
      (key) => LineHeightPercentages[key] === featuredLineHeight,
    );

    lineHeightIndex =
      !lineHeightIndex || lineHeightIndex === -1
        ? LineHeightPercentageDefaultIndex
        : parseInt(lineHeightIndex);

    return lineHeightIndex;
  },

  _getPrompterList() {
    const { columnId, rowId, remote } = this.props;
    const {
      fullScreenCuesheet,
      editorHeight,
      editorWidth,
      remoteTeleprompter,
      user,
      scale,
      scaleStyles,
    } = this.state;

    const {
      changedRows,
      teamId,
      eventId,
      itemSetId,
      userSettings,
      selectedCells,
      editingCell,
      rowOrder,
      rowMap,
    } = fullScreenCuesheet;

    let {
      autoScrollEnabled,
      autoScrollSpeedIndex,
      prompterWidthIndex,
    } = fullScreenCuesheet;

    const {
      featuredZoom,
      featuredLineHeight,
      featuredFontWeight,
    } = userSettings;

    let {
      featuredCapitalization,
      prompterTextMirror,
      prompterTextVerticalMirror,
      prompterReadArrowEnabled,
      prompterItemInfoEnabled,
      prompterSingleItemEnabled,
      prompterRealTimeEditsEnabled,
    } = userSettings;

    let {
      fontWeight,
      lineHeight,
      lineHeightIndex,
      zoom,
      zoomIndex,
    } = remoteTeleprompter;

    if (!remote) {
      fontWeight = featuredFontWeight;
      lineHeight = featuredLineHeight;
      lineHeightIndex = this._getLineHeightIndex();
      zoom = featuredZoom;
      zoomIndex = this._getZoomIndex();
    }

    if (remote) {
      autoScrollEnabled = remoteTeleprompter.autoScrollEnabled;
      prompterTextMirror = remoteTeleprompter.prompterTextMirror;
      prompterTextVerticalMirror =
        remoteTeleprompter.prompterTextVerticalMirror;
      prompterReadArrowEnabled = remoteTeleprompter.prompterReadArrowEnabled;
      prompterItemInfoEnabled = remoteTeleprompter.prompterItemInfoEnabled;
      prompterSingleItemEnabled = remoteTeleprompter.prompterSingleItemEnabled;
      prompterRealTimeEditsEnabled =
        remoteTeleprompter.prompterRealTimeEditsEnabled;
      autoScrollSpeedIndex = remoteTeleprompter.autoScrollSpeedIndex;
      autoScrollSpeedIndex = remoteTeleprompter.autoScrollSpeedIndex;
      featuredCapitalization = remoteTeleprompter.featuredCapitalization;
      prompterWidthIndex = remoteTeleprompter.prompterWidthIndex;
    }

    const prompterListProps = {
      changedRows,
      teamId,
      eventId,
      user,
      zoomIndex,
      zoom,
      lineHeight,
      lineHeightIndex,
      fontWeight,
      prompterReadArrowEnabled,
      prompterRealTimeEditsEnabled,
      prompterSingleItemEnabled,
      prompterItemInfoEnabled,
      featuredCapitalization,
      prompterWidthIndex,
      prompterTextMirror,
      prompterTextVerticalMirror,
      autoScrollEnabled,
      autoScrollSpeedIndex,
      selectedCells,
      editingCell,
      rowMap,
      rowOrder,
      remote,
      itemSetId,
      columnId,
      rowId,
      scale,
      scaleStyles,
    };

    return (
      <ReactWindowPrompterList
        height={editorHeight}
        width={editorWidth}
        loading={this._isLoading()}
        defaultRTEText={this._getDefaultRTEText()}
        onBlur={this._handleBlur}
        onSelect={this._handleSelect}
        onStartEdit={this._handleStartEdit}
        onStopEdit={this._handleStopEditing}
        onCancelEdit={this._handleCancelEditing}
        onClick={this._onClosePanelsClick}
        {...prompterListProps}
      />
    );
  },

  _onClosePanelsClick() {
    const { fullScreenCuesheet } = this.state;

    const { rowPanel, utilityPanel } = fullScreenCuesheet;

    if (rowPanel) FullScreenCuesheetActions.togglePanel('rowPanel', false);
    if (utilityPanel)
      FullScreenCuesheetActions.togglePanel('utilityPanel', false);
  },

  _isLoading() {
    const { columnId, rowId } = this.props;
    const { fullScreenCuesheet } = this.state;

    return fullScreenCuesheet.loadingPrompter ||
      fullScreenCuesheet.loading ||
      !columnId ||
      !rowId
      ? true
      : false;
  },

  _isEventContributor() {
    const { fullScreenCuesheet, user } = this.state;
    const { teamId, eventId } = fullScreenCuesheet;

    return role.hasEventContributorRole(user, teamId, eventId);
  },

  _getDefaultRTEText() {
    return this._isEventContributor() ? defaultRteText : '(empty cell)';
  },

  _handleBlur(rowId, columnId, editorState) {
    const isEditing = this._isCellInEditMode(rowId, columnId);

    if (!isEditing) return;

    this._handleStopEditing(rowId, columnId, editorState);
  },

  _handleSelect(rowId, columnId) {
    const { remote } = this.props;
    if (this._isEventContributor() && !remote)
      FullScreenCuesheetActions.cellSelect(rowId, columnId);
  },

  _handleStartEdit(rowId, columnId) {
    keyBinder.setScope(KeyScopes.FullScreenEditing);
    FullScreenCuesheetActions.disableAutoScrolling();
    FullScreenCuesheetActions.cellEdit(rowId, columnId);
  },

  _handleCancelEditing(e) {
    e.preventDefault();
    e.stopPropagation();
    keyBinder.setScope(KeyScopes.FullScreen);

    FullScreenCuesheetActions.clearEditing();
  },

  _handleStopEditing(rowId, columnId, editorState) {
    FullScreenCuesheetActions.saveDataCellChanges(rowId, columnId, editorState);
    FullScreenCuesheetActions.clearEditing();
    keyBinder.setScope(KeyScopes.FullScreen);
  },

  _getEditorStateText(item) {
    if (!item) return '';
    const { columnId } = this.props;

    const text = item.cells[columnId] ? item.cells[columnId].text : '';

    return text;
  },

  _isCellInEditMode(rowId, columnId) {
    const { editingCell } = this.state.fullScreenCuesheet;
    if (!editingCell) return false;
    return editingCell.rowId === rowId && editingCell.columnId === columnId;
  },

  _getRows() {
    const { fullScreenCuesheet } = this.state;
    const { rowMap, itemSetId } = fullScreenCuesheet;

    if (!rowMap || !itemSetId) return [];

    return rowMap[itemSetId].rows ? rowMap[itemSetId].rows : [];
  },

  _getRowItem() {
    const { rowId } = this.props;
    const { fullScreenCuesheet } = this.state;
    const { rowMap, itemSetId } = fullScreenCuesheet;

    if (!rowId || !rowMap || !itemSetId) return null;

    return rowMap[itemSetId].rows[rowId]
      ? rowMap[itemSetId].rows[rowId].item
      : null;
  },

  _updateDimensions() {
    const dimensions = this._getDimensions();
    let { editorWidth } = dimensions;
    const { panelWidth, editorHeight, windowHeight } = dimensions;

    let scale = editorWidth / FixedEditorWidth;
    const translatePercentage = ((1 / scale - 1) / 2) * -100;

    const scaleStyles = {
      transform: `scale(${scale}) translateY(${translatePercentage}%)`,
    };

    this.setState({
      panelWidth,
      editorWidth,
      editorHeight,
      windowHeight,
      scale,
      scaleStyles,
    });
  },

  _getDimensions() {
    const { innerWidth, innerHeight } = getInnerWindowDimensions();
    let panelWidth = innerWidth * 0.125 + 20;
    const readArrowPadding = 70;

    if (panelWidth < 230) panelWidth = 230;

    const maxWidth = innerWidth - 2 * readArrowPadding;

    const dimensions = {
      panelWidth,
      editorWidth: maxWidth,
      editorHeight: innerHeight,
      windowHeight: innerHeight,
    };

    return dimensions;
  },
});
